
// --- Vue & Template imports ---
import { Component, Prop, Vue } from 'vue-property-decorator';

// --- Models ---

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party ---

@Component
export default class LoginPage extends Vue {
  user = {
    username: '',
    password: '',
  };

  valid: boolean = false;
  clicked: boolean = false;
  showPassword: boolean = false;
  
  rules = {
      required: (value: string) => !!value || '',
  };

  async login() {
    try {
      this.clicked = true;

      const response = await AuthService.login({ 
        username: this.user.username, 
        password: this.user.password,
      });

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          this.$router.push('/');
          
        }
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }

    } catch (error) {
      if (error.response) {
        AppService.errorHandler(error.response.statusText);
      } else {
        AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
      }
    } finally {
      this.clicked = false;
    }
  }

}
